import { MouseEventHandler } from "react"
import { Snippet } from "../../model/Snippet"
import { ViewMode } from "../../model/ViewMode"

interface SnippetControlsProps {
    snippets?: Array<Snippet>
    allSnippets: boolean
    autoComplete: boolean
    viewMode: ViewMode
    onAddSnippet: (snippet: Snippet) => MouseEventHandler<HTMLDivElement>
    onToggleSnippets: MouseEventHandler<HTMLDivElement>
    onToggleFullScreen: MouseEventHandler<HTMLDivElement>
    onToggleAutocomplete: MouseEventHandler<HTMLDivElement>
    viewModeTitle: string
}

export const SnippetControls = ({
    snippets,
    allSnippets,
    autoComplete,
    viewMode,
    onAddSnippet,
    onToggleSnippets,
    onToggleFullScreen,
    onToggleAutocomplete,
    viewModeTitle
}: SnippetControlsProps) => {
    if (!snippets) {
        return null
    }

    const marginLeft = snippets ? (allSnippets ? snippets.length * -32 - 36 : -36) : 0

    const snippetsPosStyle = {
        marginLeft: marginLeft.toString() + 'px',
    }

    const viewModeClasses = ['snippet']
    if (viewMode === ViewMode.FULL_SCREEN) {
        viewModeClasses.push('fullScreen')
    } else if (viewMode === ViewMode.RIGHT_PANEL) {
        viewModeClasses.push('rightPanel')
    } else {
        viewModeClasses.push('noFullScreen')
    }

    return (
        <div className="snippets">
            <div className="snippetsInner" style={snippetsPosStyle}>
                {allSnippets && snippets.map((snippet, index) => (
                    <div
                        key={"snippet_" + index.toString()}
                        onMouseDown={onAddSnippet(snippet)}
                        className={"snippet " + snippet.className}
                        title={snippet.tooltip}
                    >
                        {snippet.title}
                    </div>
                ))}
                <div
                    className={"snippet " + (allSnippets ? 'visible' : 'hidden')}
                    onMouseDown={onToggleSnippets}
                    title={allSnippets ? 'Hide snippets (F8)' : 'Show snippets (F8)'}
                />
                <div
                    className={"autoComplete" + (autoComplete ? ' visible' : '')}
                    onMouseDown={onToggleAutocomplete}
                    title={autoComplete ? 'Disable auto complete' : 'Enable autocomplete'}
                />
                <div
                    className={viewModeClasses.join(' ')}
                    onMouseDown={onToggleFullScreen}
                    title={viewModeTitle}
                />
            </div>
        </div>
    )
}
